let body = document.body;
let menuToggle = document.querySelector("#hamburger-button");
let menu = document.querySelector("#menu");
let menuClose = document.querySelector("#menu-close");
let subMenuButton = document.querySelectorAll(".submenu-toggle");
let subMenuBack = document.querySelectorAll(".back-submenu");
let submenuDropDown = document.querySelectorAll(".header-dropdown");
let toggleNavDropdown = document.querySelector(".toggle-nav-dropdown");
let headerOverlay = document.querySelector(".header-overlay");

let toggleNav = document.querySelectorAll(".toggle-nav-btn");
let toggleNavWrap = document.querySelector(".toggle-nav-dropdown");
let toggleNavBack = document.querySelectorAll(".toggle-nav-back");
let dropDownClose = document.querySelectorAll(".dropdown-close");
let menuSecondLabel = document.querySelectorAll(".header-dropdown-navigation");
let headerWrapper = document.querySelector("header").clientHeight;
let anouncementBar = document.querySelector(".announcement");

if (anouncementBar) {
    anouncementBarHeight = anouncementBar.clientHeight;
}
var prevScrollpos = window.pageYOffset;

/* Get the header element and it's position */
var headerDiv = document.querySelector("#shopify-section-header-new");
var headerBottom = headerDiv.offsetTop + headerDiv.clientHeight;
var productStickyBar = document.querySelector(".product-sticky-bar");
var searchDrawerWrap = document.querySelector("#SearchDrawer");
var plpStickyBar = document.querySelector(".plp-bredcrumbs_container");




// menu open
menuToggle.addEventListener("click", () => {
    if (window.innerWidth > 1200) return;
    body.classList.add("no-scroll");
    menu.classList.add("menu-active");
    menuClose.classList.add("menu-close-active");
    menuToggle.classList.add("hide");
    headerOverlay.classList.add("header-overlay-active");
})
document.addEventListener('click', (e) => {
    if (e.target.getAttribute("id") != "hamburger-button" && !e.target.closest("#hamburger-button") && e.target.getAttribute("id") != "menu" && !e.target.closest("#menu")) {
        console.log('running')
        if (window.innerWidth > 1200) return;
        body.classList.remove("no-scroll");
        menu.classList.remove("menu-active");
        menuClose.classList.remove("menu-close-active");
        menuToggle.classList.remove("hide");
        if (toggleNavDropdown) {
            toggleNavDropdown.classList.remove("toggle-nav-active");
        }
        headerOverlay.classList.remove("header-overlay-active");
        submenuClose();
    }
})

// all submenu close
function submenuClose() {
    submenuDropDown.forEach((e) => {
        e.classList.remove("header-dropdown-active");
    })
}


// menu close
menuClose.addEventListener("click", () => {
    if (window.innerWidth > 1200) return;
    body.classList.remove("no-scroll");
    menu.classList.remove("menu-active");
    menuClose.classList.remove("menu-close-active");
    menuToggle.classList.remove("hide");
    if (toggleNavDropdown) {
        toggleNavDropdown.classList.remove("toggle-nav-active");
    }
    headerOverlay.classList.remove("header-overlay-active");
    submenuClose();
})

// submenu open
subMenuButton.forEach((e) => {
    e.addEventListener("click", () => {
        if (window.innerWidth > 1200) return;
        const subMenuWrap = e.nextElementSibling;
        subMenuWrap.classList.add("header-dropdown-active")
    })
})

// submenu back
subMenuBack.forEach((backBtn) => {
    backBtn.addEventListener("click", () => {
        if (window.innerWidth > 1200) return;
        const backMenuWrap = backBtn.closest(".header-dropdown");
        backMenuWrap.classList.remove("header-dropdown-active");
    })
})

// toggle nav open
toggleNav.forEach((toggleBtn) => {
    toggleBtn.addEventListener("click", () => {
        //if(window.innerWidth > 1200) return;
        toggleNavWrap.classList.add("toggle-nav-active");
        //toggleBtn.classList.remove("active-nav-btn"); 

        // toggleBtn 
        const toggleBtnClick = toggleBtn.getAttribute("data-id");
        Array.from(document.querySelectorAll(`.header-l2.toggle-l2-nav, .toggle-nav-btn`)).forEach(el => el.classList.remove("active-toggle-nav"));
        Array.from(document.querySelectorAll(`.toggle-nav-btn`)).forEach(el => el.classList.remove("active-nav-btn"));
        toggleBtn.classList.add("active-nav-btn");
        document.querySelector(`.header-l2.toggle-l2-nav[data-id="${toggleBtnClick}"]`).classList.add("active-toggle-nav");



    })
})

// toggle nav back
toggleNavBack.forEach((toggleBtnBack) => {
    toggleBtnBack.addEventListener("click", () => {
        if (window.innerWidth > 1200) return;
        toggleNavWrap.classList.remove("toggle-nav-active");
    })
})


// desktop menu on hover item open
let menuItem = document.querySelectorAll(".top-level-nav .navbar-items-2lavel");
menuItem.forEach((e) => {
    e.addEventListener("mouseover", ((itemHoverEl) => {
        const selectItem = itemHoverEl.target.closest(".navbar-items-2lavel");
        selectItem.classList.add("navbar-active");
        headerOverlay.classList.add("header-overlay-active");
    }))
    e.addEventListener("mouseout", ((itemHoverEl) => {
        const selectItem = itemHoverEl.target.closest(".navbar-items-2lavel");
        selectItem.classList.remove("navbar-active");
        headerOverlay.classList.remove("header-overlay-active");
    }))
})



// dropdown close
dropDownClose.forEach((dropClose) => {
    dropClose.addEventListener("click", () => {
        const parentItem = dropClose.closest(".navbar__item");
        parentItem.classList.remove("navbar-active");
    })
})



// search drawer open desktop 
// let seachBtnDesk = document.querySelector(".site-header__search-togglen");
// seachBtnDesk.addEventListener("click", ()=>{
//  if (window.innerWidth < 767) return;
//  let searchDrawerrap = document.querySelector("#glFilter-search-popup");
//  if(searchDrawerrap){
//    setTimeout(()=>{
//      searchDrawerrap.classList.add("search-parent-active");
//    }, 300)
//  }
// })





function stickyHeader() {
    var headerHeight = headerDiv.clientHeight;
    let searchButton = document.querySelector(".site-header__search-togglen");
    // header sticky desktop on scroll
    if (window.innerWidth > 1198) {
        menu.style.top = 0 + "px";
        menu.style.height = "auto";
        window.onscroll = function() {
            //if(window.innerWidth < 1200) return;
            var currentScrollPos = window.pageYOffset;
            /* if scrolling down, let it scroll out of view as normal */
            if (prevScrollpos <= currentScrollPos) {
                headerDiv.style.top = + - +headerHeight + "px";
                if (productStickyBar) {
                    productStickyBar.style.top = "0";
                }
                if (searchDrawerWrap) {
                    searchDrawerWrap.style.top = "0";
                }
                if (plpStickyBar) {
                    plpStickyBar.style.top = "0";
                  setTimeout(() => {
                    var plpSideBar = document.querySelector(".gf-filter-contents");
                    var plpStickyBarHeight = plpStickyBar.clientHeight;
                    if (plpSideBar) {
                        plpSideBar.style.top = plpStickyBarHeight + "px";
                    }

                }, 100)
                  }
            }
            /* otherwise if we're scrolling up, fix the nav to the top */
            else {
                headerDiv.style.top = "0";
                if (productStickyBar) {
                    productStickyBar.style.top = headerHeight + "px";
                }
                if (searchDrawerWrap) {
                    searchDrawerWrap.style.top = headerHeight + "px";
                }
                if (plpStickyBar) {
                    plpStickyBar.style.top = headerHeight + "px";
                setTimeout(() => {
                    var plpSideBar = document.querySelector(".gf-filter-contents");
                    var plpStickyBarHeight = plpStickyBar.clientHeight;
                    var plpTopSticky = plpStickyBarHeight + headerHeight;
                    //alert(plpTopSticky, "plpTopSticky")
                    if (plpSideBar) {
                        plpSideBar.style.top = plpTopSticky + "px";
                    }

                }, 100)
                  }

            }
            prevScrollpos = currentScrollPos;
        }

    } else {


        if (window.scrollY == 0) {
            if (anouncementBar) {
                let headerFullHeight = anouncementBarHeight + headerHeight;
                console.log(headerFullHeight, "height displayed here")
                //console.log(headerFullHeight, "headerFullHeight aa jgsjgda");
                menu.style.top = headerFullHeight + "px";
                //console.log(menu.getAttribute("style"),"here");
                menu.style.height = "calc(100vh - 160px)";
                if (submenuDropDown) {
                    submenuDropDown.forEach((e) => {
                        e.style.top = headerFullHeight + "px";
                        e.style.height = "calc(100vh - 160px)";
                    })
                }
                if (menuSecondLabel) {
                    menuSecondLabel.forEach((secondLabel) => {
                        secondLabel.style.top = headerFullHeight + "px";
                        secondLabel.style.height = "calc(100vh - 160px)";
                    })
                }
                // header search
                searchButton.addEventListener("click", ()=>{
                  let searchMobile = document.querySelector(".gl-filter-search-fullscreen");
                  if(searchMobile){
                    searchMobile.style.top = headerFullHeight + "px";
                  }
                })
                
              
            } else {
                console.log('no announcement bar')
                menu.style.top = headerHeight + "px";
                menu.style.height = "calc(100vh - " + headerHeight + "px)";
                if (submenuDropDown) {
                    submenuDropDown.forEach((e) => {
                        e.style.top = headerHeight + "px";
                        e.style.height = "calc(100vh - " + headerHeight + "px)";
                    })
                }
                if (menuSecondLabel) {
                    menuSecondLabel.forEach((secondLabel) => {
                        secondLabel.style.top = headerHeight + "px";
                        secondLabel.style.height = "calc(100vh - " + headerHeight + "px)";
                    })
                }

              // header search
                searchButton.addEventListener("click", ()=>{
                  let searchMobile = document.querySelector(".gl-filter-search-fullscreen");
                  if(searchMobile){
                    searchMobile.style.top = headerHeight + "px";
                  }
                })

            }
        }


        // mobile on scroll 
        window.onscroll = function() {
            //if(window.innerWidth > 1199) return;
            var currentScrollPos = window.pageYOffset;
            /* if scrolling down, let it scroll out of view as normal */
            if (prevScrollpos <= currentScrollPos && window.scrollY !== 0) {
                menu.style.top = headerHeight + "px";
                menu.style.height = "calc(100vh - " + headerHeight + "px)";
                if (submenuDropDown) {
                    submenuDropDown.forEach((e) => {
                        e.style.top = headerHeight + "px";
                        e.style.height = "calc(100vh - " + headerHeight + "px)";
                    })
                }
                if (menuSecondLabel) { 
                    menuSecondLabel.forEach((secondLabel) => {
                        secondLabel.style.top = headerHeight + "px";
                        secondLabel.style.height = "calc(100vh - " + headerHeight + "px)";
                    })
                }
                 // header search
                searchButton.addEventListener("click", ()=>{
                    let searchMobile = document.querySelector(".gl-filter-search-fullscreen");
                    if(searchMobile){
                      searchMobile.style.top = headerHeight + "px";
                    }
                  })
            }
            /* otherwise if we're scrolling up, fix the nav to the top */
            else {
                menu.style.top = headerHeight + "px";
                menu.style.height = "calc(100vh - " + headerHeight + "px)";
                if (window.scrollY == 0) {
                    if (anouncementBar) {
                        let headerFullHeight = anouncementBarHeight + headerHeight;
                        menu.style.top = headerFullHeight + "px";
                        menu.style.height = "calc(100vh - 160px)";

                      if (submenuDropDown) {
                          submenuDropDown.forEach((e) => {
                              e.style.top = headerFullHeight + "px";
                              e.style.height = "calc(100vh - 160px)";
                          })
                      }
                      if (menuSecondLabel) {
                          menuSecondLabel.forEach((secondLabel) => {
                              secondLabel.style.top = headerFullHeight + "px";
                              secondLabel.style.height = "calc(100vh - 160px)";
                          })
                      }
                      // header search
                        searchButton.addEventListener("click", ()=>{
                            let searchMobile = document.querySelector(".gl-filter-search-fullscreen");
                            if(searchMobile){
                              searchMobile.style.top = headerFullHeight + "px";
                            }
                          })
                    }
                }
            }
            prevScrollpos = currentScrollPos;
        }

    }
}



stickyHeader();

window.addEventListener("resize", stickyHeader)